import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TrackingPageFacade } from '../store/tracking-page';
import { StorageService } from 'app/core';
import { isDefined } from 'app/helpers';

@Injectable()
export class TrackingPageGuard implements CanActivate {
  constructor(
    private trackingPageFacade: TrackingPageFacade,
    private storageService: StorageService
  ) {}

  canActivate({
    params,
    queryParams
  }: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (isDefined(queryParams.lang)) {
      this.storageService.setItem('selectedLocale', queryParams.lang);
    }
    const locale = this.storageService.getItem('selectedLocale');
    this.trackingPageFacade.bootstrapTrackingPage(
      params.hash ?? 'test',
      locale
    );
    return true;
  }
}
